import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "../Config";
import { attachMarketingUser } from "./marketingAttribution";
import { encryptData } from "../Authentication/encryption";
import { decryptData } from "../Authentication/decryptData";

/**
 * Common Google browser login handler
 *
 * @param {Object} params
 * @param {string} params.credential Google credential token
 * @param {Function} params.onSuccess Success callback
 * @param {Function} params.onError Error callback
 */
export const handleGoogleBrowserLogin = async ({
  credential,
  onSuccess,
  onError,
}) => {
  if (!credential) {
    onError?.("Google authentication failed. Please try again.");
    return;
  }

  try {
    const googleUser = jwtDecode(credential);

    const payload = {
      googleId: googleUser.sub,
      email: googleUser.email,
      name: googleUser.name || "",
      profilePic: googleUser.picture || "",
      accessToken: credential,
    };

    const encryptedSignInData = encryptData(payload);

    const response = await axios.post(
      `${config.apiBaseUrl}/${config.googleSignIn}`,
      { encryptedData: encryptedSignInData },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const responseData = decryptData(response.data);

    /**
     * Adjust this according to your backend response structure.
     */
    const userDoc =
      responseData?.userDoc ||
      responseData?.data?.userDoc ||
      responseData?.user;

    const newToken =
      responseData?.newToken ||
      responseData?.data?.newToken ||
      responseData?.token;

    if (!userDoc || !newToken) {
      throw new Error("Invalid Google login response.");
    }

    const userId = userDoc.userId || userDoc._id;

    const userEmail = userDoc.email || googleUser.email;

    const userContact = userDoc.contact || userDoc.phone || null;

    if (userId) {
      sessionStorage.setItem("userId", userId);
    }

    sessionStorage.setItem("newToken", newToken);

    if (userEmail) {
      sessionStorage.setItem("userEmail", userEmail);
    }

    if (userContact) {
      sessionStorage.setItem("userContact", userContact);
    }

    await attachMarketingUser({
      userId,
      email: userEmail,
      contact: userContact,
    });

    onSuccess?.({
      userDoc,
      newToken,
      userId,
      userEmail,
      userContact,
    });
  } catch (error) {
    console.error("Google browser login error:", error);

    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Google login failed. Please try again.";

    onError?.(message);
  }
};
